import {mapGetters, mapActions}    from 'vuex'

var moment   = require('moment');

moment.locale();

export default {
	data () {
		return {
			descripClima:'',
			temperatura:0,
			iconClima:null,
			tareas_programadas:[],
      countTareas:0,
		}
	},
	computed: {
		...mapGetters('Carrito', ['getCarrito']),
		...mapGetters('login', ['getdatosUsuarioERPERP','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos']),
    ...mapGetters('tema', ['getTema']),
    ...mapGetters('Carrito',['getCarrito']),
	},

	methods: {
    ...mapActions('login', ['salirLogin','cambiarEscuela','abrirProspecto','cambiarEstatusLlamada','addTareas','traerProspectosNuevos']),

    getHttpErrorMessage(error, fallback = 'Error en el servidor') {
      return (error && error.response && error.response.data && error.response.data.message)
        || (error && error.body && error.body.message)
        || (error && error.body)
        || (error && error.message)
        || fallback
    },

		getClima(){
    },

    getMiCalendario( ){
      // Obtener todos los ciclos
      this.$http.get('micalendario/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
        this.events = response.data
        this.cargar = false
        const momentoActual = new Date();
        const horaLocal = momentoActual.getHours();
        const minutoLocal = momentoActual.getMinutes();
        const segundoLocal = momentoActual.getSeconds();
        const diaActual = moment(momentoActual).format().substr(0, 10);

        let tareas  = response.data.filter( el => el.hoy == 1 )
        this.actividadesHoy = response.data.filter( el => el.hoy == 1 ).length

        for (const tarea of tareas ) {
          const { hora, notificada, nota, dia, name } = tarea;
          const horaTarea = moment(hora, 'HH:mm:ss');
          const horaSistema = moment(`${horaLocal}:${minutoLocal}:00`, 'HH:mm:ss');

          // Calcular la diferencia en minutos entre la hora de la tarea y la hora actual
          const diferenciaMinutos = horaTarea.diff(horaSistema, 'minutes');

          // Notificar si la diferencia es 0 (hora exacta) o 5 minutos antes, y no se ha notificado antes
          if ((diferenciaMinutos === 0 || diferenciaMinutos === 5) && !notificada && dia === diaActual) {
            const greeting = new Notification(name, {
              body: nota,
              icon: 'https://web-back-inbi.club/iconosclima/info.png',
              vibrate: [200, 100, 200],
              requireInteraction: true
            });
          }
        }
      }).catch( error =>{
        this.validarError(this.getHttpErrorMessage(error, 'Error al cargar calendario'))
      }).finally( () => { this.cargar = false })
    },

    getTareasProgramadas ( ) {
      this.addTareas([])

      this.tareas_programadas = []
      this.countTareas = 0
      this.$http.get('prospectos.tarea.usuario/' + this.getdatosUsuarioERPERP.iderp).then((response) => {
        this.tareas_programadas = response.data
        // Vamos a agregar el campo de tarea programada
        for(const i in this.tareas_programadas){
          this.tareas_programadas[i].notificada = false
        }
        this.addTareas(this.tareas_programadas)
        this.drawer2 = !this.drawer2

        const tareasHoy = this.tareas_programadas.filter(el=> { return el.hoy == 1})
        this.countTareas = tareasHoy.length

        return
      }).catch(error=>{
        // INdicamos que hay un error en el back
        this.error = this.getHttpErrorMessage(error, 'Error al cargar tareas programadas')
        this.errorBack = true
        this.overlay = false
        this.dialogError = true
      })
    },

    getTareasProgramadasFormulario ( ) {

      const usuario = this.$store.getters['login/getdatosUsuarioERPERP'];
      if (!usuario || ![12, 18].includes(usuario.idpuesto)) return;

      this.addTareas([])

      this.tareas_programadas = []
      this.countTareas = 0
      this.$http.get('reclutadora.tarea.usuario/' + this.getdatosUsuarioERPERP.iderp).then((response) => {
        this.tareas_programadas = response.data
        // Vamos a agregar el campo de tarea programada
        for(const i in this.tareas_programadas){
          this.tareas_programadas[i].notificada = false
        }
        this.addTareas(this.tareas_programadas)
        this.drawer2 = !this.drawer2

        const tareasHoy = this.tareas_programadas.filter(el=> { return el.hoy == 1})
        this.countTareas = tareasHoy.length

        return
      }).catch(error=>{
        // INdicamos que hay un error en el back
        this.error = this.getHttpErrorMessage(error, 'Error al cargar tareas programadas')
        this.errorBack = true
        this.overlay = false
        this.dialogError = true
      })
    },

    getComisionesVendedora( ){

      // Ticket 80179: los lunes el bloqueo de comisiones empieza a las 12:00
      const ahora = new Date()
      if( ahora.getDay() === 1 && ahora.getHours() < 12 ) return

      if( this.getdatosUsuarioERPERP.idpuesto == 18 ){


        this.overlay = true;
        const payload = {
          fecha     : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          id_usuario: this.getdatosUsuarioERPERP.iderp,
        }

        return this.$http.post("encargadas_comisiones.get.comisionesestatus", payload).then((response) => {

          let estatus = 0

          if ( response.data.length > 0){

            estatus = response.data[0].estatus

          } else {

            estatus = 0

          }

          if( [0,4].includes( estatus ) ){

            this.paramsComisiones.estatus = true

          }
        }).catch((error) => {
          // INdicamos que hay un error en el back
          this.error = this.getHttpErrorMessage(error, 'Error al cargar comisiones');
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });

      }
    },

    getTicketsPorUsuario( ){

      this.overlay = true;

      if( this.getLogeado ){
        return this.$http.get("tickets.usuario.erp/" + this.getdatosUsuarioERPERP.iderp ).then((response) => {

          if( response.data.length > 5 && this.getdatosUsuarioERPERP.iderp != 568 ){

            this.paramsTickets.estatus = true

          }


        }).catch((error) => {

          console.log( error )
          // INdicamos que hay un error en el back
          if (error.data.message) {
            this.error = error.data;
          } else {
            this.error = error.data;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
      }


    }

  }
}
